{
  "oneOf": {
    "J5AuthV1AuthenticationMethod": {
      "external": "External",
      "jwt": "JWT",
      "session": "Session"
    },
    "J5AuthV1MethodAuthType": {
      "cookie": "Cookie",
      "custom": "Custom",
      "jwtBearer": "JWT Bearer",
      "none": "None"
    }
  }
}